import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const mmtc_buy_requestApi = createAsyncThunk("mmtc_buy_request", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/mmtc_buy_request",{ params });
  return response.data;
});

const mmtc_buy_requestSlice = createSlice({
  name: "mmtc_buy_request",
  initialState: {
    mmtc_buy_request: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mmtc_buy_requestApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mmtc_buy_requestApi.fulfilled, (state, action) => {
        state.mmtc_buy_request = action.payload;
        state.loading = false;
      })
      .addCase(mmtc_buy_requestApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mmtc_buy_requestSlice.reducer;
